import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HotelService } from '../services/hotel.service';
import { Hotel } from '../hotel';

import { MessageService } from '../services/message.service';

import * as jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas';
import { Http, RequestOptions, Headers, ResponseContentType } from '@angular/http';

@Component({
  selector: 'app-viewbill',
  templateUrl: './viewbill.component.html',
  styleUrls: ['./viewbill.component.css']
})
export class ViewbillComponent implements OnInit {

  @ViewChild('print') print: ElementRef
  constructor(private hotelService: HotelService,private http: Http, private messageService: MessageService, private activatedroute: ActivatedRoute) { }

  ngOnInit() {
    let bill_no = this.activatedroute.snapshot.params['id'];
    this.getViewBills(bill_no);
this.getUnits();
    $(document).on('focus', 'input[readonly]', function () {
      this.blur();
    });
  }
  model = new Hotel;
  rates: any;
  obj: any;
  extra_items: any;
  units: any;
  getUnits(){
    this.hotelService
      .getUnits({})
      .subscribe(profiles => {
        this.units = profiles;
        // console.log(profiles);
      })
  }
  length:any;
  getViewBills(bill_no) {
    this.obj = { "bill_no": bill_no };
    this.hotelService
      .getViewBill(this.obj)
      .subscribe(rates => {
        this.rates = rates;
        this.model = rates;
        if(rates.extra_items){
          this.extra_items = JSON.parse(rates.extra_items)
          this.length = this.extra_items.length
        }
        // Object.assign(this.model, this.rates);
        // console.log();
      })
  }

  prints() {
   // window.print()

    let bill = this.model.bill_no;
    let server;
    if (location.hostname != "localhost") {
      server = "http://" + location.hostname + "/tejashreecode/index.php/hotel/";
    }
    else {
      server = "http://" + location.hostname + "/tejashree/tejashreecode/index.php/hotel/";
    }

    let headers = new Headers({ 'Content-Type': 'application/json' });
    headers.append('Accept', 'application/json');
    let options = new RequestOptions({ headers: headers });     
    
    return this.http.post(server + "pdf_bill",{bill_no:bill},{responseType: ResponseContentType.Blob}).map(res => {
      return {
        filename: this.model.hotelname+"_"+bill+".pdf",
        data: res.blob()
      };
    })
    .subscribe(res => {
        console.log('start download:',res);
        let url = window.URL.createObjectURL(res.data);
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = res.filename;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      }, error => {
        console.log('download error:', JSON.stringify(error));
      }, () => {
        console.log('Completed file download.');
      });
    
  }

  ConvertToInt(val){
    return parseInt(val);
  }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/tejashree/src/app/viewbill/viewbill.component.ts